import React from "react";

const SocialProof = () => {
  return (
    <div className="flex items-center gap-2 bg-amber-50 border border-solid border-amber-200 rounded-full px-4 py-1.5 mb-6 mx-auto w-fit">
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <svg key={i} width="13" height="13" viewBox="0 0 24 24" fill="#f59e0b">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        ))}
      </div>
      <span className="text-[12px] font-semibold text-amber-800">
        Best selling app on monday.com for 2 years in a row
      </span>
      <span className="text-[11px] bg-amber-400 text-white px-1.5 py-0.5 rounded-full font-semibold tracking-wide">
        #1
      </span>
    </div>
  );
};

export default SocialProof;
